import { connect } from 'react-redux'
import { compose } from 'recompose'

import ContentClaims from './component'

export default compose(connect())(ContentClaims)
